import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/customer/me", { withCredentials: true });
      setCustomer(data);
    } catch {
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const register = async ({ email, password, name }) => {
    const { data } = await api.post(
      "/customer/register",
      { email, password, name },
      { withCredentials: true },
    );
    setCustomer(data);
    return data;
  };

  const login = async ({ email, password }) => {
    const { data } = await api.post(
      "/customer/login",
      { email, password },
      { withCredentials: true },
    );
    setCustomer(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/customer/logout", {}, { withCredentials: true });
    } catch {}
    setCustomer(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ customer, loading, checkAuth, register, login, logout, setCustomer }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => {
  const ctx = useContext(CustomerAuthContext);
  if (!ctx) throw new Error("useCustomerAuth must be used inside CustomerAuthProvider");
  return ctx;
};
